export const GET_MY_COMPANIES = gql`
  query GetMyCompanies {
    getMyCompanies {
      companyId
      companyName
      companySlug
      timezone
      companyLogo
      employeeId
      isCurrentEmployeeId
      trainingEnabled
      voiceAgentEnabled
      voeOutboundEnabled
      voeVoiceAgentEnabled
      expirationTrackingEnabled
      documentIntelligenceEnabled
    }
  }
`

export const UPDATE_CURRENT_EMPLOYEE_ID = gql`
  mutation UpdateCurrentEmployeeId($input: UpdateCurrentEmployeeIdInput!) {
    updateCurrentEmployeeId(input: $input)
  }
`

export const BEFORE_LOGOUT = gql`
  mutation BeforeLogout {
    beforeLogout
  }
`

export const GET_MY_MFA_STATUS = gql`
  query GetMyMFAStatus {
    getMyMFAStatus
  }
`

export const ENABLE_MFA = gql`
  mutation EnableMFA {
    enableMFA {
      success
      message
    }
  }
`

export const DISABLE_MFA = gql`
  mutation DisableMFA {
    disableMFA {
      success
      message
    }
  }
`

export const RESET_MFA = gql`
  mutation ResetMFA($input: ResetMFAInput) {
    resetMFA(input: $input) {
      success
      message
    }
  }
`
